export const DEFAULT_LANGUAGE = 'de'

/*
 * container ids from the outer DOM to render react portals with trigger buttons
 * */
export const TRIGGER_CONTAINER_IDS: string[] = [
  'ai-search-app-trigger-desktop',
]

/*
 * dismiss timeout / animation duration for mark as read
 * */
export const SNACKBAR_AUTO_DISMISS_DURATION = 3000

/*
 * slide animation duration
 * */
export const SLIDE_ANIMATION_DURATION = 300

export const PROMPT_MAX_LENGTH = 400

export const CHAT_REPLY_CHUNK_LENGTH = 60